module.exports = __webpack_public_path__ + "img/wenn-trauma-und-trauer-aufeinandertreffen.aff5370e.jpg";